// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-panel-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(220, 224, 255, 0.411);
  align-items: center;  
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Login/LoginPanel/LoginPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;AACrB","sourcesContent":[".login-panel-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: rgba(220, 224, 255, 0.411);\n  align-items: center;  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
